var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-slide-x-transition',[(_vm.currentComponent)?_c(_vm.currentComponent,{tag:"component",on:{"selected":_vm.changeSelection}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }